























































































import { Component } from "vue-property-decorator";
import { Category, MyChannel } from "@/services/apiService/api.types";
import apiStorageInterface from "@/services/apiStorageInterface";
import { Categories } from "@/helpers/constants";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import SpatialNavigation from "spatial-navigation-js";
import { Action, Getter } from "vuex-class";
import { Namespace } from "@/store/types";
import {
  ChannelChangeAction,
  ChannelChangeGetter
} from "@/components/channelChange/types";
import { ChannelEpgParams, OverlayAction } from "@/components/overlay/types";
import { EpgHandler } from "@/mixins/EpgHandler";
import { mixins } from "vue-class-component";
import dayjs from "dayjs";
import LockIcon from "@/assets/svg/svg-settings/LockIcon.vue";
import { getTranslatedCategory } from "@/helpers/utils";

@Component({
  components: { LockIcon }
})
export default class ChannelList extends mixins(EpgHandler) {
  @Action(ChannelChangeAction.UpdateSource, {
    namespace: Namespace.ChannelChange
  })
  updateSource!: (src: string) => void;

  @Action(ChannelChangeAction.UpdateOffset, {
    namespace: Namespace.ChannelChange
  })
  updateOffset!: (offset: number) => void;

  @Action(OverlayAction.UpdateChannelEpg, {
    namespace: Namespace.Overlay
  })
  updateChannelEpg!: (channelEpgParams?: ChannelEpgParams) => Promise<void>;

  @Getter(ChannelChangeGetter.GetSource, {
    namespace: Namespace.ChannelChange
  })
  getSource!: string;

  categories!: Record<Categories, Category>;
  filteredCategories: Categories[] = [];
  activeCategoryIndex = 0;

  KeySet = KeySet;

  focusedChannelIndex = 0;

  getTranslatedCategory = getTranslatedCategory;

  async mounted(): Promise<void> {
    this.categories = await apiStorageInterface.fetchSortedCategories();
    await this.filteredCategoriesFunc();
    this.focusActiveChannel();
    this.mockEpg(this.channelsByCategory[this.focusedChannelIndex].id);
    SpatialNavigation.focus("#channelList");
  }

  //filters out categories with no channels
  async filteredCategoriesFunc(): Promise<void> {
    if (this.categories) {
      this.categories[Categories.AllChannels].channels =
        await apiStorageInterface.fetchCustomChannelList();
      Object.entries(this.categories).forEach(([key, value]) => {
        if (value.channels) {
          this.filteredCategories.push(key as Categories);
        }
      });
    }
    this.filteredCategories.sort((a, b) => a.localeCompare(b));
  }

  changeCategory(direction: KeySet): void {
    if (direction === KeySet.KEY_LEFT && this.activeCategoryIndex > 0) {
      this.activeCategoryIndex--;
    }

    if (
      direction === KeySet.KEY_RIGHT &&
      this.activeCategoryIndex < this.filteredCategories.length - 1
    ) {
      this.activeCategoryIndex++;
    }
  }

  listChannels(direction: KeySet): void {
    if (direction === KeySet.KEY_UP && this.focusedChannelIndex > 0) {
      this.focusedChannelIndex--;
    }
    if (
      direction === KeySet.KEY_DOWN &&
      this.channelsByCategory &&
      this.focusedChannelIndex < this.channelsByCategory?.length - 1
    ) {
      this.focusedChannelIndex++;
    }
  }

  //set source and offset of desired channel thus triggering player to play the new channel
  playChannel(channel?: MyChannel): void {
    if (this.channelsByCategory) {
      if (!channel) {
        this.updateSource(
          this.channelsByCategory[this.focusedChannelIndex].videoLive
        );
        this.updateOffset(0);
        return;
      }

      this.updateSource(channel?.videoLive as string);
      this.updateOffset(0);
      this.focusActiveChannel();
      return;
    }
  }

  //used to set clicked channel as active
  focusActiveChannel(): void {
    this.channelsByCategory.forEach((channel, index) => {
      if (channel.videoLive === this.getSource) {
        this.focusedChannelIndex = index;
      }
    });
  }

  //used to trigger setting mock epg list and active epg item for preview
  mockEpg(channelId: number): void {
    // set daily epg list to be the one of the currently focused channel
    setTimeout(() => {
      this.updateChannelEpg({ channelId: channelId }).then(() => {
        this.updateActiveEpgItem(true);
      });
    }, 300);
  }

  //all channels of the active category
  get channelsByCategory(): MyChannel[] {
    this.focusedChannelIndex = 0;
    return this.categories[
      this.filteredCategories[this.activeCategoryIndex] as Categories
    ].channels as MyChannel[];
  }

  //channels from active category that are being shown
  get channelsShown(): MyChannel[] {
    return this.channelsByCategory.filter((channel, index) => {
      return (
        //(focusedChannelIndex - 3) can bo negative but it can be ignored since array indexes can't have such a value
        index >= this.focusedChannelIndex - 3 &&
        index <= this.focusedChannelIndex
      );
    });
  }

  get arrowLeft(): string {
    return require("/src/assets/svg/left.svg");
  }

  get arrowRight(): string {
    return require("/src/assets/svg/right.svg");
  }

  get imgPlaceholder(): string {
    return require("/src/assets/images/square-image-placeholder.jpg");
  }

  get lockIconPurple(): string {
    return require("/src/assets/svg/svg-settings/02-lock-icon-purple.svg");
  }

  channelActions(event: KeyboardEvent): void {
    //must be included in order to "lock" the currently focused element/prevent SpatialNavigation events from firing and refocusing
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_LEFT:
        this.changeCategory(KeySet.KEY_LEFT);
        break;
      case KeySet.KEY_RIGHT:
        this.changeCategory(KeySet.KEY_RIGHT);
        break;
      case KeySet.KEY_UP:
        this.listChannels(KeySet.KEY_UP);
        this.mockEpg(this.channelsShown[this.channelsShown.length - 1].id);
        break;
      case KeySet.KEY_DOWN:
        this.listChannels(KeySet.KEY_DOWN);
        this.mockEpg(this.channelsShown[this.channelsShown.length - 1].id);
        break;
      case KeySet.KEY_ENTER:
        this.playChannel();
        break;
    }
  }

  beforeDestroy(): void {
    //reset epg to currently played channel
    const date = dayjs()
      .subtract(this.getOffset, "second")
      .format("YYYY-MM-DD");
    this.updateChannelEpg({ date: date });
  }
}
